import React from 'react';

import { List, Typography } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';

import { CmiDigestAdminUser } from '../types';
import CmiDigestAdminListItem from './CmiDigestAdminListItem';
import CmiDigestAdminPagination from './CmiDigestAdminPagination';

const Container = styled.div`
  padding: 15px 30px 30px;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 0 14px 15px;
`;

const HeaderTitle = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.5px;
`;

const StyledList = styled(List)`
  && .ant-list-item:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  && .ant-list-item:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

type Props = {
  users: CmiDigestAdminUser[];
  loading: boolean;
  isMultipleSelection: boolean;
  selectedIds: number[];
  allSelected: boolean;
  onToggleAll: () => void;
  onToggleSelect: (user: CmiDigestAdminUser) => void;
  onRowClick: (user: CmiDigestAdminUser) => void;
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
};

const CmiDigestAdminList = ({
  users,
  loading,
  isMultipleSelection,
  selectedIds,
  allSelected,
  onToggleAll,
  onToggleSelect,
  onRowClick,
  page,
  pageSize,
  total,
  onPageChange,
}: Props) => {
  return (
    <Container>
      <HeaderRow>
        {isMultipleSelection && (
          <Checkbox
            checked={allSelected}
            onChange={onToggleAll}
            style={{ marginRight: '15px' }}
            data-test-id="cmi-digest-admin-select-all-checkbox"
          />
        )}
        <HeaderTitle>USER</HeaderTitle>
      </HeaderRow>
      <StyledList
        bordered
        loading={loading}
        dataSource={users}
        renderItem={(user: any) => (
          <CmiDigestAdminListItem
            key={user.id}
            user={user}
            isMultipleSelection={isMultipleSelection}
            isSelected={selectedIds.includes(user.id)}
            onToggleSelect={onToggleSelect}
            onClick={onRowClick}
          />
        )}
      />
      <CmiDigestAdminPagination
        page={page}
        pageSize={pageSize}
        total={total}
        currentPageCount={users.length}
        onPageChange={onPageChange}
      />
    </Container>
  );
};

export default CmiDigestAdminList;
